<template>
  <div class="content-section">
    <h2 class="page-title">推广管理</h2>
    <p>使用以下推广工具，邀请更多用户加入平台。</p>
    <div class="promotion-container">
      <div class="promotion-item">
        <h4><i class="el-icon-link"></i> 推广链接</h4>
        <div class="qrcode-placeholder">
          <i class="el-icon-news"></i>
          <span>推广链接</span>
        </div>
        <p>您的专属推广链接:</p>
        <div class="link-box">
          {{pcLink}}
          <!--<button class="copy-btn">复制</button>-->
        </div>
        <p>复制上方链接发送给潜在用户，通过此链接注册的用户将自动关联到您的账户</p>
        <div class="action-buttons" style="margin-top: 15px; justify-content: center;">
          <button class="btn btn-sm btn-primary" @click="copyLink">复制链接</button>
          <!--<button class="btn btn-sm btn-success">生成短链接</button>-->
        </div>
      </div>
      <div class="promotion-item">
        <h4 style="display: flex;align-items: center;justify-content: center"><img style="width: 26px;" src="/static/images/index/ewm.png"> 小程序推广链接</h4>
        <!--<div class="qrcode-placeholder">-->
          <!--<span>推广码二维码</span>-->
        <!--</div>-->
        <p style="color: #409EFF;"><strong>{{tgm}}</strong></p>
        <p style="margin-top: 20px;">使用说明: 通过此链接注册的用户将自动关联到您的账户</p>
        <div class="action-buttons" style="margin-top: 15px; justify-content: center;">
          <button class="btn btn-sm btn-primary" @click="copyLink2">复制链接</button>
          <!--<button class="btn btn-sm btn-success">刷新推广码</button>-->
        </div>
      </div>
      <div class="promotion-item">
        <h4 style="display: flex;align-items: center;justify-content: center"><img style="width: 26px;" src="/static/images/index/wx.png">推广小程序二维码</h4>
        <div>
          <img style="width: 200px;height: 200px;" :src="urlImg">
        </div>
        <p>微信小程序推广二维码</p>
        <p>用户扫描此码可直接进入微信小程序并自动关联</p>
        <div class="action-buttons" style="margin-top: 15px; justify-content: center;">
          <button class="btn btn-sm btn-primary" @click="downM">下载小程序码</button>
          <!--<button class="btn btn-sm btn-warning">查看教程</button>-->
        </div>
      </div>
    </div>

    <!--<div class="promotion-stats">-->
      <!--<h4 style="color: #1a3a6c; margin-bottom: 15px;">推广统计</h4>-->
      <!--<div class="stat-item">-->
        <!--<span>通过推广链接注册用户:</span>-->
        <!--<span><strong>32</strong> 人</span>-->
      <!--</div>-->
      <!--<div class="stat-item">-->
        <!--<span>通过推广码注册用户:</span>-->
        <!--<span><strong>15</strong> 人</span>-->
      <!--</div>-->
      <!--<div class="stat-item">-->
        <!--<span>通过小程序注册用户:</span>-->
        <!--<span><strong>8</strong> 人</span>-->
      <!--</div>-->
      <!--<div class="stat-item">-->
        <!--<span>成功转化案件:</span>-->
        <!--<span><strong>12</strong> 件</span>-->
      <!--</div>-->
      <!--<div class="stat-item">-->
        <!--<span>推广总佣金:</span>-->
        <!--<span style="color: #28a745; font-weight: bold;">¥8,450</span>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        url: {
          list: SZH.assets.api + '/Custom/GetCustomBankCardList',
          GetWxUrlPromotion: SZH.assets.api + '/WeChat/GetWxUrlPromotion',//1、微信小程序推广链接
          GetWxQRCodePromotion: SZH.assets.api + '/WeChat/GetWxQRCodePromotion',//1、2、微信小程序推广二维码
          GetPCUrlPromotion: SZH.assets.api + '/WeChat/GetPCUrlPromotion',//1、获取PC网页推广链接
        },
        pcLink:'',
        tgm:'',
        urlImg:''
      }
    },
    methods: {
      downM(){
        window.open(this.urlImg)
      },
      copyLink(){
        if (navigator.clipboard) {
          navigator.clipboard.writeText(this.pcLink).then(() => {
            this.$message.success('复制成功！');
          }).catch(err => {
            console.error('复制失败: ', err);
          });
        } else {
          // 方法2: 使用传统的execCommand
          // 创建一个临时的textarea元素来执行复制
          const textArea = document.createElement('textarea');
          textArea.value = this.pcLink;
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            this.$message.success('复制成功！');
          } catch (err) {
            console.error('复制失败: ', err);
          }
          document.body.removeChild(textArea);
        }
      },
      copyLink2(){
        if (navigator.clipboard) {
          navigator.clipboard.writeText(this.tgm).then(() => {
            this.$message.success('复制成功！');
          }).catch(err => {
            console.error('复制失败: ', err);
          });
        } else {
          // 方法2: 使用传统的execCommand
          // 创建一个临时的textarea元素来执行复制
          const textArea = document.createElement('textarea');
          textArea.value = this.tgm;
          document.body.appendChild(textArea);
          textArea.select();
          try {
            document.execCommand('copy');
            this.$message.success('复制成功！');
          } catch (err) {
            console.error('复制失败: ', err);
          }
          document.body.removeChild(textArea);
        }
      },
      getPC(){
        let self = this;
        self.$http.post(self.url.GetPCUrlPromotion,{})
          .then(result => {
            if (result.state == true) {
              self.pcLink = result.data;
            } else {
              self.pcLink = '';
              self.$message.error(result.message);
            }

          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      getMiniLink(){
        let self = this;
        self.$http.post(self.url.GetWxUrlPromotion,{})
          .then(result => {
            if (result.state == true) {
              self.tgm = result.data.F_PromotionLinkUri_WX;
            } else {
              self.tgm = '';
            }

          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
      getMiniImg(){
        let self = this;
        self.$http.post(self.url.GetWxQRCodePromotion,{})
          .then(result => {
            if (result.state == true) {
              self.urlImg = SZH.assets.image + result.data.F_PromotionORCodeImgUrl
            } else {
              self.urlImg = '';
            }

          }, () => {
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });
      },
    },
    computed: {},
    components: {
    },
    mounted() {
      this.getPC();
      this.getMiniImg();
      this.getMiniLink();
    }
  }
</script>

<style scoped>
  .promotion-container {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    margin-top: 20px;
  }

  .promotion-item {
    flex: 1;
    min-width: 250px;
    background-color: #f9f9f9;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
  }

  .promotion-item h4 {
    margin-bottom: 15px;
    color: #1a3a6c;
  }

  .qrcode-placeholder {
    width: 150px;
    height: 150px;
    background-color: #e9ecef;
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    flex-direction: column;
  }

  .qrcode-placeholder i {
    font-size: 50px;
    margin-bottom: 10px;
    color: #1a3a6c;
  }

  .link-box {
    background-color: white;
    border: 1px dashed #ccc;
    padding: 10px;
    border-radius: 5px;
    margin: 10px 0;
    word-break: break-all;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .copy-btn {
    background-color: #f8f9fa;
    border: 1px solid #ddd;
    padding: 5px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    transition: background-color 0.3s;
  }

  .copy-btn:hover {
    background-color: #e9ecef;
  }

  .promotion-stats {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #eee;
  }

  .stat-item {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Me/PromotionManagement/PromotionManagement.vue